import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Input from '~/components/Form/Input';
import FormConfig from './components/FormConfig';
import * as SForm from '~/components/Form/styles';
import * as S from './styles';
import GridCell from '~/components/GridCell';

export default function EditUser({ onSubmit, onClose }) {
  const { t } = useTranslation();
  const { user } = useSelector(state => state.user);
  const { loading } = useSelector(state => state.auth);

  const areas = {
    xs:
      '"HEADER" "NAME" "SURNAME" "EMAIL" "PASSWORD" "PASSWORD2" "DNI" "MOBILE" "MEDIANAME" "MEDIATYPE" "MEDIATYPE2" "SUBMIT" "CANCEL" ',
    lg:
      '"HEADER HEADER" "NAME DNI" "SURNAME MOBILE" "EMAIL MEDIANAME" "PASSWORD MEDIATYPE" "PASSWORD2 MEDIATYPE2" "SUBMIT SUBMIT" "CANCEL CANCEL" ',
  };
  return (
    <FormConfig value={user} onSubmit={onSubmit}>
      {props => {
        // eslint-disable-next-line react/prop-types
        const { isSubmitting, handleSubmit } = props;
        return (
          <SForm.FormContainer width={100} height="auto">
            <S.EditUserForm
              hasWidth={100}
              onSubmit={handleSubmit}
              columns={2}
              areas={areas}
              hasHeight="100%"
              register
            >
              <GridCell area="HEADER" centered>
                <SForm.FormHeader>
                  <SForm.Logo vertical />
                </SForm.FormHeader>
              </GridCell>

              <GridCell area="NAME">
                <Input
                  icon="avatar"
                  type="text"
                  selector="firstName"
                  label={t('name')}
                  placeholder={t('enterName')}
                  formikProps={props}
                  disabled={loading}
                />
              </GridCell>

              <GridCell area="SURNAME">
                <Input
                  icon="avatar"
                  type="text"
                  selector="lastName"
                  label={t('lastName')}
                  placeholder={t('enterLastName')}
                  formikProps={props}
                  disabled={loading}
                />
              </GridCell>

              <GridCell area="DNI">
                <Input
                  icon="idCard"
                  type="text"
                  selector="document"
                  label={t('dni')}
                  placeholder={t('enterDNI')}
                  formikProps={props}
                  disabled={loading}
                />
              </GridCell>

              <GridCell area="MOBILE">
                <Input
                  icon="phonePortrait"
                  type="tel"
                  selector="phoneNumber"
                  label={t('telephone')}
                  placeholder={t('enterTelephone')}
                  formikProps={props}
                  disabled={loading}
                />
              </GridCell>

              <GridCell area="EMAIL">
                <Input
                  icon="mail"
                  type="email"
                  selector="email"
                  label={t('email')}
                  placeholder={t('enterEmail')}
                  formikProps={props}
                  disabled
                />
              </GridCell>
              <GridCell area="MEDIANAME">
                <Input
                  icon="idCard"
                  type="text"
                  selector="mediaName"
                  label={t('mediaNameLabel')}
                  placeholder={t('enterMediaName')}
                  formikProps={props}
                  disabled
                />
              </GridCell>

              <GridCell area="MEDIATYPE">
                <Input
                  icon="idCard"
                  type="text"
                  selector="mediaType"
                  label={t('selectMediaType')}
                  placeholder={t('mediaType')}
                  formikProps={props}
                  disabled
                />
              </GridCell>
              <S.SubmitGridCell area="SUBMIT" centered>
                <SForm.SubmitButton
                  type="submit"
                  disabled={isSubmitting || loading}
                >
                  {isSubmitting || loading ? t('loading') : t('editAccount')}
                </SForm.SubmitButton>
              </S.SubmitGridCell>
              <S.SubmitGridCell area="SUBMIT" centered>
                <SForm.SubmitButton
                  type="submit"
                  disabled={isSubmitting || loading}
                >
                  {isSubmitting || loading ? t('loading') : t('editAccount')}
                </SForm.SubmitButton>
              </S.SubmitGridCell>
              <GridCell area="CANCEL" centered>
                <SForm.CancelButton
                  onClick={onClose}
                  type="button"
                  disabled={isSubmitting || loading}
                >
                  {t('cancel')}
                </SForm.CancelButton>
              </GridCell>
            </S.EditUserForm>
          </SForm.FormContainer>
        );
      }}
    </FormConfig>
  );
}

EditUser.propTypes = {
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
};

EditUser.defaultProps = {
  onSubmit: () => {},
  onClose: () => {},
};
